/* esm.sh - es-toolkit@1.52.0/dist/_internal/globalThis */
var o=typeof globalThis=="object"&&globalThis||typeof window=="object"&&window||typeof self=="object"&&self||typeof globalThis=="object"&&globalThis||(function(){return this})();export{o as globalThis_};
//# sourceMappingURL=globalThis.mjs.map